import { render, staticRenderFns } from "./PuntosGestionIndex.vue?vue&type=template&id=77eeb5da"
import script from "./PuntosGestionIndex.vue?vue&type=script&lang=js"
export * from "./PuntosGestionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports